<template>
  <v-list two-line subheader>
    <v-dialog v-model="dialog" v-if="itemToRemove" max-width="300">
      <v-card>
        <v-card-title>
          Remove entity
          <v-icon color="warning">warning</v-icon>
        </v-card-title>
        <v-card-text>Do you want to remove {{ itemToRemove.name }}?</v-card-text>
        <v-card-actions>
          <v-container>
            <v-row>
              <v-col cols="6">
                <v-btn block @click="remove(itemToRemove)">Yes</v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn block @click="dialog = false">Cancel</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <template v-for="(item, idx) in items">
      <v-list-item :key="item.id"
        v-observe-visibility="idx === items.length - 1 && nextPageUrl !== null ? loadMore : false"
        @click="$emit('get-detail', item)" class="dense-list-item"
        :style="'border-bottom:1px solid rgba(0,0,128,.2); background-color:' + (idx % 2 !== 0 ? 'rgba(0,60,128,.1)' : 'white')">
        <v-list-item-content>
          <v-list-item-title>
            <v-container>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-container>
                    <v-row no-gutters>
                      <v-col cols="6"><b>{{ item.name }}</b></v-col>
                      <v-col cols="10" sm="4" class="text-right">
                        <!--
                        <span title="Signed"><v-icon color="success" v-if="item.signature">check_circle_outline</v-icon></span>
                        -->
                        <span title="Bank accounts"><v-icon class="ml-2">account_balance_wallet</v-icon> {{ item.bank_account_count }}</span>
                        <!--span title="Checklists"><v-icon class="ml-2">playlist_add_check</v-icon> {{ item.checklist_count }}</span-->
                        <span title="Documents"><v-icon class="ml-2">attach_file</v-icon> {{ item.document_count }}</span>
                      </v-col>
                      <v-col cols="2" class="text-right">
                        <v-btn large icon @click.stop="confirmRemove(item)" color="red lighten-3" style="margin-top:-12px">
                          <v-icon>delete_outline</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-col>
              </v-row>
            </v-container>
          </v-list-item-title>
          <v-list-item-subtitle>
            <v-container>
              <v-row no-gutters>
                <v-col cols="6" md="2">{{ item.ird }}</v-col>
                <v-col cols="6" md="2">{{ item.type_name }}</v-col>
                <v-col cols="12" md="3">{{ item.email }}</v-col>
                <v-col cols="12" md="5"><span v-if="item.address">{{ item.address.address }}</span></v-col>
              </v-row>
            </v-container>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
    <v-progress-linear v-if="loading" indeterminate></v-progress-linear>
  </v-list>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import EntityService from '@/services/EntityService'

@Component
export default class EntityList extends Vue {
  dialog = false
  itemToRemove = null
  items = []
  loading = false
  page = 1
  nextPageUrl = null

  mounted () {
    this.load()
  }

  loadMore (isVisible, entry) {
    if (isVisible) {
      this.page += 1
      this.load(true)
    }
  }

  load (append = false) {
    this.loading = true
    if (!append) {
      this.page = 1
      this.items = []
    }
    EntityService.list(this.page)
      .then(resp => {
        const items = resp.data.results || resp.data
        if (append) {
          this.items = this.items.concat(items)
        } else {
          this.items = items
        }
        this.nextPageUrl = resp.data.next
      })
      .catch(err => {
        this.nextPageUrl = null
        console.error(err)
      })
      .finally(() => {
        this.loading = false
      })
  }

  confirmRemove (item) {
    this.itemToRemove = item
    this.dialog = true
  }

  remove (item) {
    EntityService.delete(item.id)
      .then(() => {
        this.load()
      })
      .finally(() => {
        this.itemToRemove = null
        this.dialog = false
      })
  }
}
</script>

<style lang="scss" scoped>
.dense-list-item {
  @media (max-width: 600px) {
    padding: 0 !important;
    margin-left: -8px;
    margin-right: -8px;
  }
}
</style>
